import moment from "moment";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";

export const getSalesInvoiceExcelData = (expenseList) => {
    let list = JSON.parse(JSON.stringify(expenseList));
    const exportData = list.map((data, index) => {
      let content = {
        no: index + 1,
        "Invoice Number": data.inNo && InvoiceNumberFormate(data.inNo),
        "Invoice Date":
          data.inDt && moment(data.inDt).format("DD-MMM-YYYY"),
        "Due Date":
          data.duDt && moment(data.duDt).format("DD-MMM-YYYY"),
        "Currency":
          data?.inCr,
        "Major Type": data?.mjId?.val,
        "Minor Type": data?.mnId?.val,
        "Minor Sub Category": data?.msId?.val,
        "Client Name": data.clId?.clName,
        "Project Name": data.prId?.prj,
        "Remarks": data.rmks,
        "Customer Notes": data.cNts,

        "Requested Amount":`${currencySymbolByCode(data?.inCr || "INR")}  ${data.pyInfo?.apAmt  ? formatAmountIndianRupees(data.pyInfo?.apAmt) : Number(0).toFixed(2)}`,
        "Approved Amount":`${currencySymbolByCode(data?.inCr || "INR")} ${data.pyInfo?.tlAmt  ? formatAmountIndianRupees(data.pyInfo?.tlAmt) : Number(0).toFixed(2)}`,
        
        "Is It Refund Amount?": data?.rfdInfo?.sts ? "true" : "false",
       
      };
     
     
      content["Space Added"] = "--------------";
    

      
      content["Created AT"] = data.crAt ? moment(data.crAt).format("DD-MMM-YYYY") : '';

      return content;
    });
    return exportData;
  };